<template>
  <div>
    <h3 class="mt-4">Before optimization</h3>

    <OptimizationTable header-color="grey" class="table-report bg-grey-title">
      <tr v-for="(report, index) in reportData.manual" :key="'report_' + index">
        <td>{{ ucFirst(report.carrier) }}</td>
        <td>{{ ucFirst(report.productName) }}</td>
        <td>STD</td>
        <td>{{ report.itemsCount }}</td>
        <td>{{ itemsCount }} pc</td>
        <td>{{ report.averageWeight }} g</td>
        <td>{{ formattedPrice(report.averagePrice) }}</td>
        <td>{{ formattedPrice(report.totalPrice) }}</td>
      </tr>

      <tr class="footer-cells">
        <td colspan="6" class="border-0" />
        <td class="fw-400">Total</td>
        <td class="fw-400">{{ formattedPrice(totalBefore) }}</td>
      </tr>
    </OptimizationTable>
  </div>
</template>

<script lang="ts">
import type { OptimisationReport } from '@/types/Models/OptimisationReport'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { formattedPrice, ucFirst } from '@/services/Helpers'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useOptimizationReportStore } from '@/store/optimizationReport'
import OptimizationTable from '@/views/Components/Elements/Table/OptimizationTable.vue'

export default defineComponent({
  name: 'BeforeOptimizationTable',
  components: { OptimizationTable },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const optimizationReportStore = useOptimizationReportStore()

    const reportData: ComputedRef<OptimisationReport> = computed(() => optimizationReportStore.report)
    const itemsCount: ComputedRef<number> = computed(() => assignmentSummaryStore.assignment?.itemsCount || 0)
    const totalBefore: ComputedRef<string> = computed(() => optimizationReportStore.report.manualTotal)

    return {
      reportData,
      itemsCount,
      totalBefore,
      ucFirst,
      formattedPrice,
    }
  },
})
</script>
